var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolkadot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E53684",
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 38,
    height: 40,
    x: 9,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.64 8H9v40h37.64V8Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.816 16.39c3.986 0 7.217-1.878 7.217-4.195S31.803 8 27.816 8C23.83 8 20.6 9.878 20.6 12.195s3.231 4.195 7.217 4.195ZM27.816 47.997c3.986 0 7.217-1.878 7.217-4.195 0-2.316-3.23-4.195-7.217-4.195-3.986 0-7.217 1.879-7.217 4.195 0 2.317 3.231 4.195 7.217 4.195ZM17.758 22.196c1.993-3.45 1.98-7.186-.029-8.345-2.008-1.159-5.253.698-7.246 4.148-1.993 3.45-1.98 7.185.03 8.345 2.008 1.159 5.252-.698 7.245-4.148ZM45.145 37.998c1.993-3.45 1.981-7.185-.026-8.343-2.008-1.159-5.25.699-7.244 4.148-1.993 3.45-1.981 7.186.027 8.344 2.007 1.158 5.25-.7 7.243-4.149ZM17.73 42.146c2.01-1.16 2.023-4.895.03-8.345-1.993-3.45-5.237-5.307-7.246-4.147-2.01 1.159-2.022 4.895-.03 8.345 1.994 3.45 5.238 5.306 7.247 4.147ZM45.121 26.345c2.008-1.159 2.02-4.894.027-8.344-1.993-3.45-5.236-5.307-7.244-4.149-2.008 1.159-2.02 4.894-.026 8.344 1.993 3.45 5.236 5.307 7.243 4.149Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolkadot);
export default __webpack_public_path__ + "static/media/polkadot.7e356a76d93533052931dda2c013650e.svg";
export { ForwardRef as ReactComponent };